import * as Yup from 'yup';
import { Pages } from '../constants/enums';

const useFormValidations = (slug: string, action: string) => {
  const phoneRegExp =
    /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
  const loginValidation = () =>
    Yup.object().shape({
      email: Yup.string()
        .required('Email is required')
        .email('Email is invalid'),
      password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .max(40, 'Password must not exceed 40 characters'),
    });

  const nameValidation = () =>
    Yup.object().shape({
      name: Yup.string().required('Name is required'),
    });

  const typeValidation = () =>
    Yup.object().shape({
      type: Yup.string().required('Type is required'),
    });

  const accountValidation = () =>
    Yup.object().shape({
      domain: Yup.string().required('Domain is required'),
      siteTitle: Yup.string().required('Site Title is required'),
      tagline: Yup.string().required('Tagline is required'),
      description: Yup.string().required('Description is required'),
      siteAddress: Yup.string().required('Site Address is required'),
    });

  const languageValidation = () =>
    Yup.object().shape({
      name: Yup.string().required('Name is required'),
      code: Yup.string().required('Code is required'),
    });

  const featureValidation = () =>
    Yup.object().shape({
      precedence: Yup.string().required('Precedence is required'),
      name: Yup.string().required('Name is required'),
      slug: Yup.string().required('URL is required'),
    });

  const usersValidation = () =>
    Yup.object().shape({
      phone_number: Yup.string()
        .matches(/^(010|011|012|015)\d{8}$/, 'Phone number is not valid')
        .required('Phone number is required'),
      name: Yup.string().required('name is required'),
      email: Yup.string()
        .email('Email is invalid')
        .required('Email is required'),
      gender: Yup.string().required('gender is required'),
      birthdate: Yup.date()
        .max(new Date(), "birth date field can't be in the future")
        .typeError('birth date is required'),
    });

  const adminRolesValidation = () =>
    Yup.object().shape({
      name: Yup.string().required('Name is required'),
    });
  const adminGroupsValidation = () =>
    Yup.object().shape({
      name: Yup.string().required('Name is required'),
    });

  const adminsValidation = () =>
    Yup.object().shape({
      name: Yup.string()
        .required('Name is required')
        .trim(),
      email: Yup.string()
        .required('Email is required')
        .trim()
        .lowercase()
        .email('Email is invalid'),
      password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .max(256, 'Password must not exceed 256 characters'),
      confirmPassword: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('password')], 'Passwords must match'),
      group: Yup.string().required('Admin Group is required'),
    });

  const getValidationSchema = () => {
    switch (slug) {
      case Pages.LOGIN:
        return loginValidation();
      case Pages.ACCOUNTS:
        return accountValidation();
      case Pages.CONCEPTS:
        return nameValidation();
      case Pages.Parent_Concepts:
        return typeValidation();
      case Pages.FEATURES:
        return featureValidation();
      case Pages.LANGUAGES:
        return languageValidation();
      case Pages.GUESTS:
        return usersValidation();
      case Pages.ADMIN_ROLES:
        return adminRolesValidation();
      case Pages.ADMIN_GROUPS:
        return adminGroupsValidation();
      case Pages.ADMINS:
        return adminsValidation();

      default:
        return Yup.object();
    }
  };

  return {
    getValidationSchema,
  };
};

export default useFormValidations;
